import { cleanStringFromNonDigits } from '@hrlogics/helper-utils';

import { Nullable } from '@clearverify/types';

const PHONE_CODE_REGEX = /^(\+)(\d)$/;

/**
 * The phone number must be a string with no telephone code (+1 etc)
 * and no characters other than digits
 */

export const formatPhoneNumberForFormValues = (
  rawPhoneNumber: Nullable<string>,
): Nullable<string> => {
  if (!rawPhoneNumber) return rawPhoneNumber;
  let phoneNumber = rawPhoneNumber;

  // check if the phone number starts with a code
  if (PHONE_CODE_REGEX.test(phoneNumber.substring(0, 2))) {
    phoneNumber = phoneNumber.substring(2, phoneNumber.length);
  }

  phoneNumber = cleanStringFromNonDigits(phoneNumber);

  // check the string for length, if TRUE, it means there is code without +
  if (phoneNumber.length === 11) {
    phoneNumber = phoneNumber.substring(1, phoneNumber.length);
  }

  return phoneNumber;
};
